import { render, staticRenderFns } from "./BillRow.vue?vue&type=template&id=790a4876&scoped=true"
import script from "./BillRow.vue?vue&type=script&lang=js"
export * from "./BillRow.vue?vue&type=script&lang=js"
import style0 from "./BillRow.vue?vue&type=style&index=0&id=790a4876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a4876",
  null
  
)

export default component.exports